var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"sort-label",attrs:{"outlined":""},on:{"click":_vm.changeSortDirection}},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))]),_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }